<template>
  <div
    class="about-join-us-team-wrapper"
    data-test-id="component-about-join-us-team"
  >
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-medium">
      <div
        v-for="(employee, index) in employeeArray"
        :key="index"
        class="block relative mb-large"
        :data-test-id="`block-about-join-us-team-employee-${index}`"
      >
        <div class="employee-wrapper relative">
          <div class="play-icon flex absolute bg-bright-yellow text-white stretched-link h-medium w-medium justify-center items-center cursor-pointer">
            <div class="btn-play" />
          </div>
          <MajorityUiMajorityImage alt="Employee image" lazy :src="optimizeEmployeeImage(employee.img)" class="w-full" />
          <MajorityUiMajorityFlag :iso="employee.natioanlity" class="employee-nationality absolute bottom-0 left-0 h-6 w-6 bg-middle-light" is-square />
        </div>
        <button
          class="text-bigger link-unstyled stretched-link p-0"
          data-test-id="button-about-join-us-team-show-employee-video"
          @click.prevent="popupVideo(employee)"
        >
          {{ employee.name }}
        </button>
      </div>
      <div
        v-if="showJobs"
        class="block mb-standart"
        data-test-id="block-about-join-us-team-jobs"
      >
        <h2 class="h2 mb-micro">
          {{ $messages('about.career.open_positions') }}
        </h2>
        <div
          v-for="(job, index) in jobs"
          :key="index"
          class="border-bottom mb-micro relative"
          :data-test-id="`block-about-join-us-team-job-${index}`"
        >
          <MajorityUiMajorityLink
            class="text-regular m-0 block text-truncate stretched-link link-unstyled"
            :to="$mRouter.getLocalRoute({name: 'company-career-position-slug', params: { slug: job.slug }})"
            data-test-id="link-about-join-us-team-career-details"
          >
            {{ job.title }}
          </MajorityUiMajorityLink>
          <p class="opacity-muted text-smallest">
            {{ $messages('about.career.location') }} {{ job.city }}
          </p>
          <hr class="my-tiny">
        </div>
        <MajorityUiMajorityLink
          class="action-link"
          :to="$mRouter.getLocalRoute({name: 'company-career'})"
          data-test-id="link-about-join-us-team-career"
        >
          {{ $messages('about.join_us.see_all_jobs') }}
        </MajorityUiMajorityLink>
      </div>
    </div>
    <MajorityUiMajorityModal
      ref="employeeVideoModalRef"
      content-class="p-0"
      data-test-id="modal-about-join-us-team-video"
    >
      <SharedVideoPlayer
        :src="selectedVideo"
        type="video/mp4"
        :poster="selectedImg"
        autoplay
        class="w-full p-0 m-0"
        ar-class="ar-square"
      />
    </MajorityUiMajorityModal>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { careerStore } from '@/store/career'
import { optimize } from '@/utils/image-optimization'
export default {
  props: {
    showJobs: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      selectedVideo: '',
      selectedImg: ''
    }
  },
  computed: {
    ...mapState(careerStore, {
      employees: 'getRandomEmployees',
      getJobs: 'getJobs'
    }),

    employeeArray () {
      const numberOfVideo = this.showJobs ? 7 : 8
      return this.employees.slice(0, numberOfVideo)
    },
    jobs () {
      return this.getJobs().slice(0, 3)
    }
  },
  methods: {
    popupVideo (employee) {
      this.selectedVideo = employee.video
      this.selectedImg = employee.img
      this.$refs.employeeVideoModalRef.show()
    },
    optimizeEmployeeImage (url) {
      return optimize(
        url,
        false,
        { w: 400, h: 400, q: 70 }
      )
    }
  }
}
</script>

<style lang="postcss" scoped>
.play-icon {
  top: 16px;
  right: 16px;
  border-radius: 50%;

  .btn-play {
    margin-left: 2px;
    height: 13px;
    border-color: transparent transparent transparent #ffffff;

    /* play state */
    border-style: solid;
    border-width: 7px 0 7px 15px;
  }

  &:hover {
    .btn-play {
      border-color: transparent transparent transparent #f0f0f0;
    }
  }
}
</style>
